import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { listRetailers } from "../graphql/queries/listRetailers";

export const useRetailers = () => {
  const { data, loading, error, refetch } = useQuery(listRetailers, {
    variables: { field: "metadata.retailer", type: "OUTLET" },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  const retailers = useMemo(() => {
    return [...(data?.getDistinctKeywordGroupsField || [])]
      .sort((a, b) =>
        String(a).localeCompare(String(b), undefined, { sensitivity: "base" })
      )
      .map((retailer) => ({
        id: retailer,
        displayText: retailer,
      }));
  }, [data]);

  return { retailers, loading, error, refetch };
};
